import { handleActions } from 'redux-actions';

const defaultState = {
  items: [
    {
      image: require('images/new-products/ECOLD-GLS-89RR.jpg'),
      description: 'newProducts.slide1',
      link: 'http://www.elconmegarad.com/site/wp-content/uploads/2014/03/ECOLD-GLS-89RR.pdf?utm_source=Elcon+Megarad+-+Newsletter&utm_campaign=9d73389346-Elcon_Newsletter_Marzo_2016&utm_medium=email&utm_term=0_a7117de105-9d73389346-52032601',
    },
    {
      image: require('images/new-products/ECOLD-VTS.jpg'),
      description: 'newProducts.slide2',
      link: 'http://www.elconmegarad.com/wp-content/uploads/2014/03/ECOLD-VTS-TERMINATIONS-ultima-revisione.pdf',
    },
    {
      image: require('images/new-products/ELCONEXT.jpg'),
      description: 'newProducts.slide3',
      link: 'http://www.elconmegarad.com/wp-content/uploads/2015/10/ELCONEXT-PLUG-IN-TERMINATIONS.pdf',
    },
  ],
};

const reducerMap = {};

export default handleActions(reducerMap, defaultState);



/** WEBPACK FOOTER **
 ** ./web/js/reducers/newProducts.js
 **/